import type { Media, Shape, Theme } from '../../types/props'

export type Item = {
  theme?: Theme
  title: string
  description: string
  imageUrl: Media
  imageMobileUrl?: Media
  tabName?: string
  width?: 'full' | 'half' | 'one-third'
  blockLink?: string
  primaryButton: {
    text: string
    link: string
  }
  secondaryButton: {
    text: string
    link: string
  }
  video?: {
    url: string
  }
  youtubeId?: string
  isYouTube?: boolean
}

export type GraphicOverlayProps = React.HTMLAttributes<HTMLElement> & {
  data: {
    shape?: Shape
    items: ({
      width?: 'full' | 'half' | 'one-third'
    } & Item)[]
  }
}
